import { z } from 'zod';
import ky from 'ky';
import { ENV } from 'src/utils/env';
import { TASK_ACTION_MAP } from 'src/utils';
import { RESINGESTOR_BASE_SCHEMA } from '../_common';

const TIMESHIFT_SCHEMA = RESINGESTOR_BASE_SCHEMA.pick({
  index1: true,
  earliest1: true,
  latest1: true,
  source1: true,
  sourcetype1: true,
  time_offset: true,
  modify_amount: true,
  zone_name: true,
});

export type TimeShiftSchema = z.infer<typeof TIMESHIFT_SCHEMA>;

const TIMESHIFT_RESPONSE_SCHEMA = z.object({
  success: z.boolean(),
  task_id: z.string(),
});

export const reingestorTimeShiftPromise = async (param: TimeShiftSchema) => {
  const validatedParam = TIMESHIFT_SCHEMA.safeParse(param);

  if (!validatedParam.success) {
    throw new Error(`Invalid param ${JSON.stringify(validatedParam.error)}`);
  }

  const response = await ky.post(`${ENV.FRONTEND_API_URL}/reingestor`, {
    body: JSON.stringify({
      params: {
        ...validatedParam.data,
        action_type: TASK_ACTION_MAP.timeshift,
      },
    }),
  });

  if (!response.ok) {
    return false;
  }

  const responseData = await response.json();
  const validatedResponse = TIMESHIFT_RESPONSE_SCHEMA.safeParse(responseData);
  if (!validatedResponse.success) {
    console.error(validatedResponse.error);
    return false;
  }

  return validatedResponse.data?.success;
};
